export default "__VITE_ASSET__i$wd1Y4B__"